// Copyright (c) 2016 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import {getDateRangeQueryString} from '../../advanced-claim-summary/report-services/get-date-range-query-string';
import {handleError} from '../../../shared/services/error-handlers';

const basePath = '/api';

const reportsBasePath = `${basePath}/reports`;

export async function createAuditSummary(postArgs) {

    const endPoint = `${reportsBasePath}/audit-summary`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getReportLayout(reportName) {

    try {

        const endPoint = `${reportsBasePath}/${reportName}/layouts`;

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function postReportLayout(reportName, payload) {

    try {

        const endPoint = `${reportsBasePath}/${reportName}/layouts`;

        const options = {
            body: JSON.stringify(payload),
            method: 'POST'
        };

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function deleteReportLayout(reportName, layoutName) {

    try {

        const endPoint = `${reportsBasePath}/${reportName}/layouts/${encodeURIComponent(layoutName)}`;

        const options = {
            method: 'DELETE'
        };

        return await fetchService.fetch(endPoint, options);

    } catch (response) {

        return handleError(response);

    }

}

export async function createBasicWarrantyEstimator(postArgs) {

    const endPoint = `${reportsBasePath}/basic-warranty-estimator`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createClaimHistory(postArgs) {

    const endPoint = `${reportsBasePath}/claim-history`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createCreditMemo(postArgs) {

    const endPoint = `${reportsBasePath}/credit-memo`;

    const options = {
        body: JSON.stringify(postArgs),
        endpointId: 'credit-memo',
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createDealerTransferHistory(postArgs) {

    const endPoint = `${reportsBasePath}/dealer-transfer-history`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createDeliveryNoDocuments(postArgs) {

    const endPoint = `${reportsBasePath}/delivery-no-documents`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createDemoRentalHistory(postArgs) {

    const endPoint = `${reportsBasePath}/demo-rental-history`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createLaborRateHistory(postArgs) {

    const endPoint = `${reportsBasePath}/labor-rate-history`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createLaborStats(postArgs) {

    const endPoint = `${reportsBasePath}/labor-stats`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createQuestionablePart(postArgs) {

    const endPoint = `${reportsBasePath}/questionable-part`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createMaintenancePlan(postArgs) {

    const endPoint = `${reportsBasePath}/maintenance-plan`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createMassChannelCustomerFollowUp(postArgs) {

    const endPoint = `${reportsBasePath}/mass-channel-customer-followup`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createPinCrossReference(postArgs) {

    const endPoint = `${reportsBasePath}/pin-cross-reference`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createPinsNotRegistered(postArgs) {

    const endPoint = `${reportsBasePath}/pins-not-registered`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createRegistrationsReview(postArgs) {

    const endPoint = `${reportsBasePath}/registrations-review`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createSettlementNoRegistration(postArgs) {

    const endPoint = `${reportsBasePath}/settlement-no-registration`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createSpecialAllowanceClaimStatus(postArgs, tabm) {

    const endPoint = `${reportsBasePath}/special-allowance-claim-status?tabm=${tabm}`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createUpdateMachineStatusHistory(postArgs) {

    const endPoint = `${reportsBasePath}/update-machine-status-history`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createWarrantyExpiration(postArgs) {

    const endPoint = `${reportsBasePath}/warranty-expiration`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createEmissionsPartSearch(postArgs) {

    const endPoint = `${reportsBasePath}/emissions-part-search`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createPartsCoverageSearch(postArgs) {

    const endPoint = `${reportsBasePath}/parts-coverage-search`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getPlanNamesList() {

    const endPoint = `${basePath}/constants?id=PLAN_NAME`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getServiceIntervalStatusesList() {

    const endPoint = `${basePath}/constants?id=SERVINT_STAT`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getServiceIntervalTypesList() {

    const endPoint = `${basePath}/constants?id=SERVICE_INTERVAL`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function readRegistrationStatusList() {

    const endPoint = `${basePath}/constants?id=REGISTRATION_STATUS`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getPipHistory(pin) {

    const endPoint = `${basePath}/products/${pin}/pips`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getAuditStatus() {

    const endPoint = `${basePath}/reports/audit-status`;

    try {

        const response = await fetchService.fetch(endPoint);

        return await response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createOpenPipProgramsReport(postArgs) {

    const endPoint = `${reportsBasePath}/open-pip-programs`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createOpenPipsReport(postArgs) {

    const endPoint = `${reportsBasePath}/open-pips`;

    const options = {
        body: JSON.stringify(postArgs),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

/* eslint-disable complexity */

export async function createAdvancedClaimSummaryReport(criteria, selectedDealers, selectedStatuses) {

    const dealerQueryString = selectedDealers.map(dealer => '&d='.concat(dealer)).join('');
    const statusQueryString = selectedStatuses.map(status => '&claimStatus='.concat(status)).join('');
    const dateRangeQueryString = getDateRangeQueryString(criteria.claimCreated.from, criteria.claimCreated.to);
    const claimNumberQueryString = criteria.claimNumber ? `&claimNumber=${criteria.claimNumber}` : '';
    const pinQueryString = criteria.pin ? `&pin=${criteria.pin}` : '';
    const workOrderOneQueryString = criteria.workOrderOne ? `&referenceNumber1=${criteria.workOrderOne}` : '';

    const endPoint = `${basePath}/claims?isNetAmountRequested=true${dealerQueryString}${statusQueryString}${dateRangeQueryString}${claimNumberQueryString}${pinQueryString}${workOrderOneQueryString}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createDuplicatePinPlate(postArgs) {

    const endPoint = `${basePath}/products/report/pin/plate`;

    const options = {
        body: JSON.stringify(postArgs),
        cloudPreferred: true,
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function createResponsibleDealer(postArgs, exportToExcel) {

    const endPoint = exportToExcel ?
    `${basePath}/report/responsible-dealer?export=EXCEL` :
    `${basePath}/report/responsible-dealer`;

    const options = {
        body: JSON.stringify(postArgs),
        cloudPreferred: true,
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return exportToExcel ?
        response :
        response.json();

    } catch (response) {

        return handleError(response);

    }

}

/* eslint-enable complexity */



// WEBPACK FOOTER //
// ./src/reports/shared/repositories/index.js